(function () {

	//=== functions ===//

	const updateMousePosition = () => {
		const updateCursor = e => {
				document.documentElement.style.setProperty('--x', e.clientX);
				document.documentElement.style.setProperty('--y', e.clientY);
		}

		document.documentElement.addEventListener('mousemove', updateCursor); //mousemove|pointermove
	};

	const productTiltEffect = () => {

		//=== extend DOM prototype ===//

		Element.prototype.tilt = function (options) {

			const config = {
				angle: options?.angle ?? 10,
				invert: options?.invert ?? false,
				perspective: options?.perspective ?? 1000,
				reset: options?.reset ?? true,
				scale: options?.scale ?? 1,
				transformElement: options?.transformElement ? this.querySelector(options.transformElement) : this,
				transitionEasing: options?.transitionEasing ?? 'cubic-bezier(.03, .98, .52, .99)',
				transitionSpeed: options?.transitionSpeed ?? 1500,
			};

			let timeout;

			if (!config.transformElement) return;


			//=== functions ===//

			const setTransition = (el, config) => {
				if (typeof config.transitionSpeed === 'number') {
					config.transformElement.style.transition = `transform ${config.transitionSpeed}ms ${config.transitionEasing}`;

					if (timeout !== undefined) clearTimeout(timeout);

					timeout = setTimeout(() => {
						config.transformElement.style.transition = '';
					}, config.transitionSpeed);
				}
			};

			const handleOver = (e, config) => {
				setTransition(this, config);

				if (typeof config.perspective === 'number') {
					this.style.setProperty('--tilt-perspective', `${config.perspective}px`);
				}

				if (typeof config.scale === 'number') {
					this.style.setProperty('--tilt-scale', `${config.scale}`);
				}
			};

			const handleMove = (e, config) => {
				let rect = this.getBoundingClientRect();
				let x_pos = Math.ceil(e.clientX - rect.left);
				let y_pos = Math.ceil(e.clientY - rect.top);
				let w_half = rect.width / 2;
				let h_half = rect.height / 2;
				let x_rot = config.angle / h_half * (h_half - y_pos);
				let y_rot = config.angle / w_half * (w_half - x_pos);

				if (typeof config.invert === 'boolean' && config.invert) {
					x_rot *= -1;
					y_rot *= -1;
				}

				this.style.setProperty('--tilt-x', `${x_rot.toFixed(2) * -1}deg`);
				this.style.setProperty('--tilt-y', `${y_rot.toFixed(2)}deg`);
			};

			const handleOut = (e, config) => {
				this.style.setProperty('--tilt-scale', 1);

				if (typeof config.reset === 'boolean' && config.reset) {
					this.style.setProperty('--tilt-x', '0deg');
					this.style.setProperty('--tilt-y', '0deg');
				}

				setTransition(this, config);
			};


			//=== events ===//

			this.addEventListener('mouseover', e => handleOver(e, config));
			this.addEventListener('mousemove', e => handleMove(e, config));
			this.addEventListener('mouseout', e => handleOut(e, config));


			//=== initial styles ===//

			config.transformElement.style.willChange = 'transform';
			config.transformElement.style.transform = 'perspective(var(--tilt-perspective)) scale(var(--tilt-scale)) rotateX(var(--tilt-x)) rotateY(var(--tilt-y))';
		};


		let options = {
			//angle: 10,
			//invert: false,
			perspective: 500,
			//reset: true,
			scale: 1.1,
			//transitionEasing: 'cubic-bezier(.03, .98, .52, .99)',
			//transitionSpeed: 1500,
		};

		document.querySelectorAll('.woocommerce .products .product-type-simple').forEach(product => {
			simpleProductOptions = {
				...options,
				transformElement: '.product__media'
			};

			product.tilt(simpleProductOptions);
		});

		document.querySelectorAll('.woocommerce .products .product-type-variable').forEach(product => {
			variableProductOptions = {
				...options,
				//transformElement: '.product__image'
			};

			product.tilt(variableProductOptions);
		});
	};

	const productFlickity = () => {
		let galleries = document.querySelectorAll('.woocommerce ul.products li.product .product__variations .product__gallery');

		galleries.forEach(gallery => {

			let galleryNav = gallery.closest('li.product').querySelector('.product__variations-nav');

			let flkty = new Flickity(gallery, {
				wrapAround: true,
				//autoPlay: 5000,
				//pauseAutoPlayOnHover: true,
				imagesLoaded: true,
				lazyLoad: 1,
				asNavFor: galleryNav,
				pageDots: false,
				selectedAttraction: 0.01, //default: 0.025; higher = faster
				friction: 0.15 //default 0.28; higher = stickier & less bouncy
			});

		});
	};

	const navHoverEffect = () => {
		const update = e => {
			const linkText = this.querySelector('span');
			const tolerance = 5
			const left = 0;
			const right = linkText.clientWidth;

			let x = e.pageX - linkText.offsetLeft;

			if (x - tolerance < left) x = left;
			if (x + tolerance > right) x = right;

			linkText.style.setProperty('--x', `${x}px`);
		};

		const links = document.querySelectorAll('#nav a');

		links.forEach(link => {
			link.addEventListener('mouseenter', update);
			link.addEventListener('mouseleave', update);
		});

	};


	//=== init ===//

	updateMousePosition();
	//productTiltEffect();
	productFlickity();
	//navHoverEffect();

})();





/*
jQuery(document).ready(function ($) {

	//=== constants ===//

	const header = $('#header');



	//=== extend jQuery prototype ===//


	$.fn.isInViewport = function (isFullyInViewport = false, includeHeader = false) {
		var elementTop = $(this).offset().top;
		var elementBottom = elementTop + $(this).outerHeight();
		var viewportTop = document.documentElement.scrollTop || document.body.scrollTop;
		viewportTop = includeHeader ? viewportTop + header.height() : viewportTop;
		var viewportBottom = viewportTop + (document.documentElement.clientHeight || window.innerHeight);

		elementTop = parseInt(elementTop);
		elementBottom = parseInt(elementBottom);
		viewportTop = parseInt(viewportTop);
		viewportBottom = parseInt(viewportBottom);

		// console.clear();
		// console.log('elementTop', elementTop);
		// console.log('elementBottom', elementBottom);
		// console.log('viewportTop', viewportTop);
		// console.log('viewportBottom', viewportBottom);
		// console.log('-----');
		// console.log('isInView', elementBottom > viewportTop && elementTop < viewportBottom);
		// console.log('isFullyInView', elementTop >= viewportTop && elementBottom <= viewportBottom);

		if (isFullyInViewport)
				return elementTop >= viewportTop && elementBottom <= viewportBottom;
		else
				return elementBottom > viewportTop && elementTop < viewportBottom;
	};



	//=== functions ===//

	const scrollPadding = () => {
		const update = () => {
				const headerHeight = header.height();
				const spacing = getComputedStyle(document.body).getPropertyValue('--s');

				$('body').css('scroll-padding-top', `calc(${headerHeight}px + ${spacing})`);
		};

		update();
		$(window).on('load resize orientationchange', update);
	}



	//=== Init ===//

	//scrollPadding();

});
*/